import { css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import 'src/library/editors/elements/d-select-dropdown';
import { NewsSlideBase } from 'src/content/screens/news-slide-base';
import { t } from 'src/i18n';

@customElement('d-news-slide-fhi')
export class DNewsSlideFhi extends NewsSlideBase {
  static readonly styles = [
    ...NewsSlideBase.styles,
    css`
      :host {
        color: black;
      }
      .image-wrapper {
        background: white;
      }
      .front-image {
        width: 58cqw;
        max-height: 38.6cqw;
      }
      .logo {
        width: 11cqi;
        height: 7cqi;
        background: #393c61 url(/images/fhi.svg) 0 0 no-repeat;
        background-size: contain;
      }
      .title {
        width: 89cqw;
        height: 17.7cqw;
        padding: 2cqw 2cqw 1.5cqw 3cqw;
      }
      .description {
        width: 42cqw;
        padding: 0 2cqw 3cqw 3cqw;
      }
    `,
  ];
  render() {
    if (this.item) {
      return html`
        <div class="image-wrapper">
          <div class="logo"></div>
          <div class="title">${this.item.title}</div>
          <div class="description">${this.shortenContent(this.item.description, 240)}</div>
          ${this.item.imgUrl ? html`<img class="front-image" src="${this.item.imgUrl}" />` : nothing}
          ${this.edit
            ? html`
                <div class="controllers-position">
                  <div class="controllers">
                    <d-select-dropdown
                      controller
                      label="${t('screens.newsSlide.itemsCountLabel')}"
                      .options=${this.countOptions}
                      .value=${this.slide.itemsCount + ''}
                      @value-changed=${(e: CustomEvent<{ value: string }>) => this.onCountChanged(e)}
                    ></d-select-dropdown>
                    <d-select-dropdown
                      controller
                      label="${t('screens.newsSlide.itemDurationLabel')}"
                      .options=${this.durationOptions}
                      .value=${this.slide.itemDuration + ''}
                      @value-changed=${(e: CustomEvent<{ value: string }>) => this.onDurationChanged(e)}
                    ></d-select-dropdown>
                  </div>
                </div>
              `
            : html`<div class="overlay"></div>`}
        </div>
      `;
    }
    return html``;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-news-slide-fhi': DNewsSlideFhi;
  }
}
